// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__DiCBm","path":"style_path__3FG7Q","arrow":"style_arrow__Ro1mw"};